import axios from "axios";
export const apiURL = "https://shop.vmi.ae/backend/"

export default axios.create({
    baseURL: apiURL
})


